import { sanitizeTextForAnalytics } from "@/utils/helper"

export const addDownloadFilesAnalytics = (
  productInfo = "",
  selectedFiles = [],
  hasError = false
) => {
  // add analytics
  const selectedFileList = []
  selectedFiles.forEach(selectedObj => {
    const fileNameAndFileType = (
      selectedObj.title +
      "." +
      selectedObj.type
    ).toLowerCase()
    selectedFileList.push(fileNameAndFileType)
  })

  const selectedUrlList = selectedFiles.map(selectedObj =>
    selectedObj.url.toLowerCase()
  )
  if (selectedFileList.length && window.adobeDataLayer) {
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    const eventInfo = {
      eventAction: "pdp:design files:download",
      eventName: "pdp:design files:download",
      eventType: "navigation",
      eventMsg: hasError ? "download failed" : "success",
      eventStatus: hasError ? "failure" : "success",
      internalLinkName: selectedFileList.join(":"),
      internalLinkPosition: "pdp",
      internalLinkType: "pdp:download",
      internalLinkZoneName: "pdp:design files",
      internalLinkURL: selectedUrlList.join(":"),
      clickInternalLinks: "true",
    }
    const dataLayerProductInfo = productInfo
      ? JSON.parse(productInfo)?.productInfo
      : null
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      page,
      productInfo: dataLayerProductInfo,
    })
  }
}

export const addDownloadFilesAnalyticsInstSup = (
  productInfo = "",
  type = "",
  errMsg = "",
  link = ""
) => {
  const title = type.toLowerCase().trim()
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventInfo = {
    eventAction: `pdp:installation & support:guides:${title}`,
    eventName: `pdp:installation & support:guides:${title}`,
    eventType: "navigation",
    eventMsg: errMsg || "success",
    eventStatus: errMsg ? "failure" : "success",
    internalLinkName: `${title} | ${link.replace(
      "https://www.us.kohler.com/webassets",
      ""
    )}`,
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:installation & support:${title}`,
    internalLinkZoneName: `pdp:installation & support`,
    internalLinkURL: link,
    clickInternalLinks: "true",
  }
  const dataLayerProductInfo = productInfo
    ? JSON.parse(productInfo)?.productInfo
    : null
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
    productInfo: dataLayerProductInfo,
  })
}

export const getEventInfoProdAccordion = (
  type = "",
  needsJSON = false,
  link = "",
  errMsg = ""
) => {
  const text = type.toLowerCase().trim()
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventMsg = text === "view more" ? "n/a" : errMsg || "success"
  const eventStatus =
    text === "view more" ? "n/a" : errMsg ? "failure" : "success"
  const internalLinkName = `${text}${
    text === "specifications sheet"
      ? ` | ${link.replace("https://www.us.kohler.com/webassets", "")}`
      : ""
  }`
  const eventInfo = {
    eventAction: `${page?.category?.pageType}:specs:${text}`,
    eventName: `${page?.category?.pageType}:specs:${text}`,
    eventType: "navigation",
    eventMsg,
    eventStatus,
    internalLinkName,
    internalLinkPosition: `${page?.category?.pageType}`,
    internalLinkType: `${page?.category?.pageType}:specs:${text}`,
    internalLinkZoneName: `${page?.category?.pageType}:specs`,
    internalLinkURL: link,
    clickInternalLinks: "true",
  }
  if (needsJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const accordianAnalyticsData = (
  type = "",
  isExpanded = false,
  needsJSON = false
) => {
  const title = type.toLowerCase().trim()
  const eventInfo = {
    eventAction: `pdp:product details:filters ${
      isExpanded ? "collapse" : "expand"
    }`,
    eventName: `pdp:product details:filters ${
      isExpanded ? "collapse" : "expand"
    }`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${isExpanded ? "collapse" : "expand"}`,
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:${title}`,
    internalLinkZoneName: "pdp:product details",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (needsJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const getEventInfoInstSup = (
  title = "",
  type = "",
  avoidTitle = false,
  url = ""
) => {
  const addedTitle = avoidTitle ? "" : ":" + sanitizeTextForAnalytics(title)
  return JSON.stringify({
    eventAction: `pdp:installation and support:${type}${addedTitle}`,
    eventName: `pdp:installation and support:${type}${addedTitle}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: sanitizeTextForAnalytics(title),
    internalLinkPosition: "pdp",
    internalLinkType: "pdp:navigation",
    internalLinkZoneName: "pdp:installation and support",
    internalLinkURL: url
      ? (url.indexOf("http") === -1 ? window.location.origin : "") + url
      : "n/a",
    clickInternalLinks: "true",
  })
}
